import {
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import type { PartListItem } from "../services/PartService";

export interface PartCardProps {
  part: PartListItem;
  onClick: (part: PartListItem) => void;
}

const PartCard = ({ part, onClick }: PartCardProps) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:hover": { borderColor: "primary.main" },
      }}
    >
      <CardActionArea
        onClick={() => onClick(part)}
        data-testid={`parts-part-card-${part.id}`}
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
        }}
      >
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1" fontWeight={600} noWrap>
            {part.name}
          </Typography>

          <Stack
            direction="row"
            spacing={0.5}
            sx={{ mt: 0.5, mb: 1, flexWrap: "wrap" }}
          >
            {part.part_type && (
              <Chip
                label={part.part_type}
                size="small"
                color="primary"
                variant="outlined"
              />
            )}
            {part.manufacturer && (
              <Chip label={part.manufacturer} size="small" variant="outlined" />
            )}
          </Stack>

          {part.description && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {part.description}
            </Typography>
          )}

          {part.has_embedding && (
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{ mt: 1 }}
            >
              <CheckCircleOutlineIcon
                sx={{ fontSize: 14, color: "success.main" }}
              />
              <Typography variant="caption" color="success.main">
                Embedded
              </Typography>
            </Stack>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default PartCard;
